










import { Vue, Prop, Component } from 'vue-property-decorator'
import realGroup from '@/components/realGroup.vue'
import showDiv from '@ivy/fts/showDiv'

@Component({})
export default class LookSale extends Vue {
  @Prop() realGroupId: string

  info: any = {}
  async mounted() {
    let { data } = await this.$axios.get(
      `/api/goods/shop/search/officialAccounts/info`,
      {
        params: {
          app_id: this.realGroupId,
        },
      }
    )
    this.info = data
  }
  async showQr() {
    await showDiv(realGroup, { info: this.info })
  }
}
